// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as InvoiceTokenRouteImport } from './routes/invoice.$token'
import { Route as ClinicTokenRouteImport } from './routes/clinic.$token'
import { Route as CTokenRouteImport } from './routes/c.$token'
import { Route as BookingTokenRouteImport } from './routes/booking.$token'
import { Route as BookTokenRouteImport } from './routes/book.$token'
import { Route as AppWeatherRouteImport } from './routes/app.weather'
import { Route as AppReportsRouteImport } from './routes/app.reports'
import { Route as AppReengagementRouteImport } from './routes/app.reengagement'
import { Route as AppQueueRouteImport } from './routes/app.queue'
import { Route as AppPackagesRouteImport } from './routes/app.packages'
import { Route as AppOnboardingRouteImport } from './routes/app.onboarding'
import { Route as AppLogRouteImport } from './routes/app.log'
import { Route as AppLocationsRouteImport } from './routes/app.locations'
import { Route as AppInvoicesRouteImport } from './routes/app.invoices'
import { Route as AppDrillsRouteImport } from './routes/app.drills'
import { Route as AppClinicsRouteImport } from './routes/app.clinics'
import { Route as AppClientsRouteImport } from './routes/app.clients'
import { Route as AppCalendarRouteImport } from './routes/app.calendar'
import { Route as AppBookingsRouteImport } from './routes/app.bookings'
import { Route as AppAdminRouteImport } from './routes/app.admin'
import { Route as AppSettingsIndexRouteImport } from './routes/app.settings.index'
import { Route as ClinicRTokenRouteImport } from './routes/clinic.r.$token'
import { Route as CVTokenRouteImport } from './routes/c.v.$token'
import { Route as AppSettingsStorageRouteImport } from './routes/app.settings.storage'
import { Route as AppSettingsPolicyRouteImport } from './routes/app.settings.policy'
import { Route as AppSettingsExportRouteImport } from './routes/app.settings.export'
import { Route as AppSettingsBillingRouteImport } from './routes/app.settings.billing'
import { Route as AppSessionsSessionIdRouteImport } from './routes/app.sessions.$sessionId'
import { Route as AppInvoicesInvoiceIdRouteImport } from './routes/app.invoices_.$invoiceId'
import { Route as AppClinicsClinicIdRouteImport } from './routes/app.clinics_.$clinicId'
import { Route as AppClientsClientIdRouteImport } from './routes/app.clients_.$clientId'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => rootRouteImport
          })
const InvoiceTokenRoute = InvoiceTokenRouteImport.update({
            id: '/invoice/$token',path: '/invoice/$token',getParentRoute: () => rootRouteImport
          })
const ClinicTokenRoute = ClinicTokenRouteImport.update({
            id: '/clinic/$token',path: '/clinic/$token',getParentRoute: () => rootRouteImport
          })
const CTokenRoute = CTokenRouteImport.update({
            id: '/c/$token',path: '/c/$token',getParentRoute: () => rootRouteImport
          })
const BookingTokenRoute = BookingTokenRouteImport.update({
            id: '/booking/$token',path: '/booking/$token',getParentRoute: () => rootRouteImport
          })
const BookTokenRoute = BookTokenRouteImport.update({
            id: '/book/$token',path: '/book/$token',getParentRoute: () => rootRouteImport
          })
const AppWeatherRoute = AppWeatherRouteImport.update({
            id: '/app/weather',path: '/app/weather',getParentRoute: () => rootRouteImport
          })
const AppReportsRoute = AppReportsRouteImport.update({
            id: '/app/reports',path: '/app/reports',getParentRoute: () => rootRouteImport
          })
const AppReengagementRoute = AppReengagementRouteImport.update({
            id: '/app/reengagement',path: '/app/reengagement',getParentRoute: () => rootRouteImport
          })
const AppQueueRoute = AppQueueRouteImport.update({
            id: '/app/queue',path: '/app/queue',getParentRoute: () => rootRouteImport
          })
const AppPackagesRoute = AppPackagesRouteImport.update({
            id: '/app/packages',path: '/app/packages',getParentRoute: () => rootRouteImport
          })
const AppOnboardingRoute = AppOnboardingRouteImport.update({
            id: '/app/onboarding',path: '/app/onboarding',getParentRoute: () => rootRouteImport
          })
const AppLogRoute = AppLogRouteImport.update({
            id: '/app/log',path: '/app/log',getParentRoute: () => rootRouteImport
          })
const AppLocationsRoute = AppLocationsRouteImport.update({
            id: '/app/locations',path: '/app/locations',getParentRoute: () => rootRouteImport
          })
const AppInvoicesRoute = AppInvoicesRouteImport.update({
            id: '/app/invoices',path: '/app/invoices',getParentRoute: () => rootRouteImport
          })
const AppDrillsRoute = AppDrillsRouteImport.update({
            id: '/app/drills',path: '/app/drills',getParentRoute: () => rootRouteImport
          })
const AppClinicsRoute = AppClinicsRouteImport.update({
            id: '/app/clinics',path: '/app/clinics',getParentRoute: () => rootRouteImport
          })
const AppClientsRoute = AppClientsRouteImport.update({
            id: '/app/clients',path: '/app/clients',getParentRoute: () => rootRouteImport
          })
const AppCalendarRoute = AppCalendarRouteImport.update({
            id: '/app/calendar',path: '/app/calendar',getParentRoute: () => rootRouteImport
          })
const AppBookingsRoute = AppBookingsRouteImport.update({
            id: '/app/bookings',path: '/app/bookings',getParentRoute: () => rootRouteImport
          })
const AppAdminRoute = AppAdminRouteImport.update({
            id: '/app/admin',path: '/app/admin',getParentRoute: () => rootRouteImport
          })
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
            id: '/app/settings/',path: '/app/settings/',getParentRoute: () => rootRouteImport
          })
const ClinicRTokenRoute = ClinicRTokenRouteImport.update({
            id: '/clinic/r/$token',path: '/clinic/r/$token',getParentRoute: () => rootRouteImport
          })
const CVTokenRoute = CVTokenRouteImport.update({
            id: '/c/v/$token',path: '/c/v/$token',getParentRoute: () => rootRouteImport
          })
const AppSettingsStorageRoute = AppSettingsStorageRouteImport.update({
            id: '/app/settings/storage',path: '/app/settings/storage',getParentRoute: () => rootRouteImport
          })
const AppSettingsPolicyRoute = AppSettingsPolicyRouteImport.update({
            id: '/app/settings/policy',path: '/app/settings/policy',getParentRoute: () => rootRouteImport
          })
const AppSettingsExportRoute = AppSettingsExportRouteImport.update({
            id: '/app/settings/export',path: '/app/settings/export',getParentRoute: () => rootRouteImport
          })
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
            id: '/app/settings/billing',path: '/app/settings/billing',getParentRoute: () => rootRouteImport
          })
const AppSessionsSessionIdRoute = AppSessionsSessionIdRouteImport.update({
            id: '/app/sessions/$sessionId',path: '/app/sessions/$sessionId',getParentRoute: () => rootRouteImport
          })
const AppInvoicesInvoiceIdRoute = AppInvoicesInvoiceIdRouteImport.update({
            id: '/app/invoices_/$invoiceId',path: '/app/invoices/$invoiceId',getParentRoute: () => rootRouteImport
          })
const AppClinicsClinicIdRoute = AppClinicsClinicIdRouteImport.update({
            id: '/app/clinics_/$clinicId',path: '/app/clinics/$clinicId',getParentRoute: () => rootRouteImport
          })
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
            id: '/app/clients_/$clientId',path: '/app/clients/$clientId',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,AppAdminRoute: AppAdminRoute,AppBookingsRoute: AppBookingsRoute,AppCalendarRoute: AppCalendarRoute,AppClientsRoute: AppClientsRoute,AppClinicsRoute: AppClinicsRoute,AppDrillsRoute: AppDrillsRoute,AppInvoicesRoute: AppInvoicesRoute,AppLocationsRoute: AppLocationsRoute,AppLogRoute: AppLogRoute,AppOnboardingRoute: AppOnboardingRoute,AppPackagesRoute: AppPackagesRoute,AppQueueRoute: AppQueueRoute,AppReengagementRoute: AppReengagementRoute,AppReportsRoute: AppReportsRoute,AppWeatherRoute: AppWeatherRoute,BookTokenRoute: BookTokenRoute,BookingTokenRoute: BookingTokenRoute,CTokenRoute: CTokenRoute,ClinicTokenRoute: ClinicTokenRoute,InvoiceTokenRoute: InvoiceTokenRoute,AppIndexRoute: AppIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,AppClientsClientIdRoute: AppClientsClientIdRoute,AppClinicsClinicIdRoute: AppClinicsClinicIdRoute,AppInvoicesInvoiceIdRoute: AppInvoicesInvoiceIdRoute,AppSessionsSessionIdRoute: AppSessionsSessionIdRoute,AppSettingsBillingRoute: AppSettingsBillingRoute,AppSettingsExportRoute: AppSettingsExportRoute,AppSettingsPolicyRoute: AppSettingsPolicyRoute,AppSettingsStorageRoute: AppSettingsStorageRoute,CVTokenRoute: CVTokenRoute,ClinicRTokenRoute: ClinicRTokenRoute,AppSettingsIndexRoute: AppSettingsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)